module.exports = __webpack_public_path__ + "media/events/RoadShow2021-4ca128c7.png";